import React from "react";
import MessageWrap from "./messageWrap";

interface MessageListProps {
	messages: any[];
	showMessage: boolean;
	selectUseCase: (value: number) => void;
	setDisabled: (param: boolean) => void;
	hideIcons?: boolean;
}

const MessageList: React.FC<MessageListProps> = React.memo(
	({ messages, showMessage, selectUseCase, setDisabled, hideIcons }) => {
		const messagesWrap = messages.map((msg) => (
			<MessageWrap
				key={`${msg.type}_${msg.time}`}
				msg={msg}
				showMessage={showMessage}
				selectUseCase={selectUseCase}
				setDisabled={setDisabled}
				hideIcons={hideIcons}
			/>
		));
		return <>{messagesWrap}</>;
	}
);

export default MessageList;
